import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74a23f52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = {
  key: 1,
  class: "upcoming"
}
const _hoisted_3 = { class: "upcoming-inner" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "upcoming-eyebrow" }, "Næste tur", -1))
const _hoisted_5 = { class: "upcoming-title" }
const _hoisted_6 = { class: "upcoming-dates" }
const _hoisted_7 = {
  key: 2,
  class: "welcome"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 3,
  class: "collage-section"
}
const _hoisted_11 = { class: "collage-strip" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "upload-prompt" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeroSection = _resolveComponent("HeroSection")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.pastTrip)
      ? (_openBlock(), _createBlock(_component_HeroSection, {
          key: 0,
          images: _ctx.heroImages,
          eyebrow: "Seneste tur",
          title: _ctx.pastTrip.location,
          dates: _ctx.formatDateRange(_ctx.pastTrip.startDate, _ctx.pastTrip.endDate),
          "link-to": `/trips/${_ctx.pastTrip.year}`
        }, null, 8, ["images", "title", "dates", "link-to"]))
      : _createCommentVNode("", true),
    (_ctx.futureTrip)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.futureTrip.location), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.formatDateRange(_ctx.futureTrip.startDate, _ctx.futureTrip.endDate)), 1),
            _createVNode(_component_router_link, {
              to: `/trips/${_ctx.futureTrip.year}`,
              class: "upcoming-link"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Se turen → ")
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.config?.welcomeTitle || _ctx.config?.welcomeText)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_ctx.config?.welcomeTitle)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_8, _toDisplayString(_ctx.config.welcomeTitle), 1))
            : _createCommentVNode("", true),
          (_ctx.config?.welcomeText)
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.config.welcomeText), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.collageImages.length > 0 && _ctx.pastTrip)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_component_router_link, {
            to: `/trips/${_ctx.pastTrip.year}`,
            class: "collage-link"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collageImages, (img, idx) => {
                  return (_openBlock(), _createElementBlock("img", {
                    key: idx,
                    src: img
                  }, null, 8, _hoisted_12))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["to"]),
          _createElementVNode("p", _hoisted_13, [
            _createTextVNode(_toDisplayString(_ctx.config?.uploadPrompt) + " ", 1),
            _createVNode(_component_router_link, {
              to: `/trips/${_ctx.pastTrip.year}?upload=true`
            }, {
              default: _withCtx(() => [
                _createTextVNode("Upload dem her.")
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}